/*
 * Copyright (c) 2025 Pegasystems Inc.
 * All rights reserved.
 */

import PubSubUtils from '../../utils/pubsub-utils';
import APP_CONSTANTS from '../../constants';

export interface SaveAssignmentCompleteInfo {
  context: string;
  assignmentID: string;
}

export const publishSaveAssignmentCompleteEvent = (data: SaveAssignmentCompleteInfo) => {
  /* publishing event to notify that save assignment has completed */
  PubSubUtils.publish(APP_CONSTANTS.PUB_SUB_EVENTS.CASE_EVENTS.SAVE_ASSIGNMENT_COMPLETE, data);
};
